import React from 'react'
import type { IButtonProps } from '../button'
import { InputText } from '../input-text'
import {
  InputCounterMinusButton,
  InputCounterPlusButton,
} from './components/input-counter-button'
import * as Comp from './input-counter.styles'
import type { TInputCounterProps } from './types'

const InputCounterRoot = ({
  children,
  testID,
  disabled,
  size = 'md',
  hasError,
  errorText = 'Valor inválido',
  readonly,
  value = 0,
  onChange,
}: TInputCounterProps) => {
  const componentProperties = {
    disabled,
    size,
    hasError,
    errorText,
    readonly,
    value: value > 0 ? value.toString() : '',
    maxLength: 3,
  }

  const renderInternalPlusButton = React.Children.map(children, child => {
    if (!React.isValidElement(child)) return

    if (React.isValidElement(child) && child.type === InputCounterPlusButton) {
      return React.cloneElement(child as React.ReactElement<IButtonProps>, {
        disabled: disabled || child.props.disabled,
        readonly,
        size,
        ...child.props,
      })
    }
  })

  const renderInternalMinusButton = React.Children.map(children, child => {
    if (!React.isValidElement(child)) return

    if (React.isValidElement(child) && child.type === InputCounterMinusButton) {
      return React.cloneElement(child as React.ReactElement<IButtonProps>, {
        disabled: disabled || child.props.disabled,
        readonly,
        size,
        ...child.props,
      })
    }
  })

  const renderInternalHelperText = React.Children.map(children, child => {
    if (!React.isValidElement(child)) return

    if (React.isValidElement(child) && child.type === InputText.HelperText) {
      return React.cloneElement(child)
    }
  })

  const renderInternalLabel = React.Children.map(children, child => {
    if (!React.isValidElement(child)) return

    if (React.isValidElement(child) && child.type === InputText.Label) {
      return React.cloneElement(child)
    }
  })

  return (
    <Comp.Root {...componentProperties} testID={testID}>
      <Comp.Container>
        <InputText.Root
          {...componentProperties}
          testID="input-counter-text-input"
          onChangeText={(value: string) => {
            if (!/^\d*$/.test(value) || value.length > 3) {
              return
            }
            onChange(Number(value))
          }}
        >
          {renderInternalLabel}
          <InputText.Actions>
            {renderInternalMinusButton}
            <InputText.Field textAlign="center" errorText={errorText} />
            {renderInternalPlusButton}
          </InputText.Actions>
          {renderInternalHelperText}
        </InputText.Root>
      </Comp.Container>
    </Comp.Root>
  )
}

export const InputCounter = {
  Root: InputCounterRoot,
  Label: InputText.Label,
  HelperText: InputText.HelperText,
  MinusButton: InputCounterMinusButton,
  PlusButton: InputCounterPlusButton,
}

export type { TInputCounterProps }
